import { DirectiveOptions, VueConstructor } from "vue";
import { userModule } from "@/store/modules/user";
import { FormAction } from "@/utils/form-access";

/**
 * Directive `v-form-access` — hide element kalau user tidak punya akses.
 *
 * Pemakaian:
 *   <v-btn v-form-access="['general_consent_ranap', 'create']">Tambah</v-btn>
 *   <v-text-field v-form-access="['visum_et_repertum', 'edit']" />
 *
 * Element akan di-removeChild dari DOM kalau false. Untuk hide tanpa unmount,
 * gunakan v-if dengan userModule.canAccessForm(...).
 */
const vFormAccess: DirectiveOptions = {
  bind(el, binding) {
    const value = binding.value;
    if (!Array.isArray(value) || value.length < 1) {
      // eslint-disable-next-line no-console
      console.warn(
        "[v-form-access] Expected array [formCode, action?]. Got:",
        value
      );
      return;
    }
    const [formCode, action = "view"] = value as [string, FormAction?];
    if (!userModule.canAccessForm(formCode, action)) {
      el.parentNode?.removeChild(el);
    }
  }
};

export function registerFormAccessDirective(Vue: VueConstructor): void {
  Vue.directive("form-access", vFormAccess);
}

export default vFormAccess;
